import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/DiamondTransactions.css";

const DiamondTransactions = () => {
  const [workers, setWorkers] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [colors, setColors] = useState([]);
  const [ledger, setLedger] = useState([]);

  const [selectedWorker, setSelectedWorker] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [cts, setCts] = useState("");
  const [type, setType] = useState("ISSUE");

  useEffect(() => {
    fetchWorkers();
    fetchDiamondOptions();
    fetchLedger();
  }, []);

  const fetchWorkers = async () => {
    const { data } = await supabase
      .from("WORKERS")
      .select("*")
      .eq("status", true);
    setWorkers(data || []);
  };

  const fetchDiamondOptions = async () => {
    const { data } = await supabase
      .from("DIAMONDS")
      .select("size, color")
      .eq("status", true);

    const uniqueSizes = [...new Set(data.map((d) => d.size))];
    const uniqueColors = [...new Set(data.map((d) => d.color))];

    setSizes(uniqueSizes);
    setColors(uniqueColors);
  };

  const fetchLedger = async () => {
    const { data } = await supabase
      .from("DIAMOND_TRANSACTIONS")
      .select("*, WORKERS(worker_name)")
      .order("created_at", { ascending: false });

    setLedger(data || []);
  };

  const submitTransaction = async () => {
    if (!selectedWorker || !selectedSize || !selectedColor || !cts) {
      alert("Please fill all fields");
      return;
    }

    await supabase.from("DIAMOND_TRANSACTIONS").insert([
      {
        worker_id: selectedWorker,
        size: selectedSize,
        color: selectedColor,
        cts,
        type,
      },
    ]);

    setCts("");
    fetchLedger();
  };

  return (
    <div className="master-page">
      <div className="master-card">
        <h2 className="master-title">💎 Diamond Issue / Receive</h2>

        <label>Select Worker</label>
        <select
          value={selectedWorker}
          onChange={(e) => setSelectedWorker(e.target.value)}
        >
          <option value="">Select Worker</option>
          {workers.map((w) => (
            <option key={w.id} value={w.id}>
              {w.worker_name}
            </option>
          ))}
        </select>

        <label>Select Size</label>
        <select
          value={selectedSize}
          onChange={(e) => setSelectedSize(e.target.value)}
        >
          <option value="">Select Size</option>
          {sizes.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>

        <label>Select Color</label>
        <select
          value={selectedColor}
          onChange={(e) => setSelectedColor(e.target.value)}
        >
          <option value="">Select Color</option>
          {colors.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>

        <label>CTS</label>
        <input
          type="number"
          value={cts}
          onChange={(e) => setCts(e.target.value)}
          placeholder="Enter CTS"
        />

        <label>Action</label>

        {/* FIXED: wrap inside container so label rules don't break layout */}
        <div className="radio-row">
          <label className="radio-label">
            <input
              type="radio"
              name="action"
              checked={type === "ISSUE"}
              onChange={() => setType("ISSUE")}
            />
            Issue
          </label>

          <label className="radio-label">
            <input
              type="radio"
              name="action"
              checked={type === "RECEIVE"}
              onChange={() => setType("RECEIVE")}
            />
            Receive
          </label>
        </div>

        <button className="gold-btn" onClick={submitTransaction}>
          ✔ Submit
        </button>
      </div>
    </div>
  );
};

export default DiamondTransactions;
